import { SchedulesTypes } from '@mode/shared/contract-common';
import { PaginationTypes } from '@mode/shared/contract-common';
import { ActionReducerMap, createReducer, on } from '@ngrx/store';
import * as ScheduleActions from './schedule.actions';

export const scheduleFeatureKey = 'workspaceSettingsSchedules';

export interface SchedulesState {
  schedules: SchedulesTypes.Schedule[] | null;
  pagination: PaginationTypes.Pagination;
  isLoading: boolean;
  query: string;
  filters: string;
  sort: string;
  hasDeletedSchedules: boolean;
  minimumScheduleInterval: string | null;
  availableIntervals: string[];
}

export const schedulesInitialState: SchedulesState = {
  schedules: null,
  pagination: {
    page: 0,
    per_page: 0,
    count: 0,
    total_pages: 0,
    total_count: 0,
  },
  isLoading: false,
  query: '',
  filters: '',
  sort: '',
  hasDeletedSchedules: false,
  minimumScheduleInterval: null,
  availableIntervals: [],
};

export const schedulesReducer = createReducer(
  schedulesInitialState.schedules,
  on(ScheduleActions.loadSchedulesSuccess, (state, action) => action.schedules)
);

export const paginationReducer = createReducer(
  schedulesInitialState.pagination,
  on(ScheduleActions.loadSchedulesSuccess, (state, action) => action.pagination)
);

export const isLoadingReducer = createReducer(
  schedulesInitialState.isLoading,
  on(ScheduleActions.loadSchedules, (state) => true),
  on(ScheduleActions.loadSchedulesSuccess, (state, action) => false),
  on(ScheduleActions.loadSchedulesFailure, (state, action) => false)
);

export const queryReducer = createReducer(
  schedulesInitialState.query,
  on(ScheduleActions.loadSchedules, (state, action) => action.query)
);

export const filtersReducer = createReducer(
  schedulesInitialState.filters,
  on(ScheduleActions.updateSchedulesFilter, (state, { filter }) => filter)
);

export const sortReducer = createReducer(
  schedulesInitialState.sort,
  on(ScheduleActions.updateSchedulesSort, (state, { sort }) => sort)
);

export const hasDeletedSchedulesReducer = createReducer(
  schedulesInitialState.hasDeletedSchedules,
  on(ScheduleActions.loadSchedules, () => false),
  on(ScheduleActions.deleteScheduleSuccess, () => true),
  on(ScheduleActions.bulkDeleteScheduleSuccess, () => true)
);

export const minimumScheduleIntervalReducer = createReducer(
  schedulesInitialState.minimumScheduleInterval,
  on(ScheduleActions.loadScheduleIntervalThresholdSuccess, (_, { minimumScheduleInterval }) => minimumScheduleInterval),
  on(
    ScheduleActions.updateScheduleIntervalThresholdSuccess,
    (_, { minimumScheduleInterval }) => minimumScheduleInterval
  )
);

export const availableIntervalsReducer = createReducer(
  schedulesInitialState.availableIntervals,
  on(ScheduleActions.loadScheduleIntervalThresholdSuccess, (_, { availableIntervals }) => availableIntervals)
);

export const reducer: ActionReducerMap<SchedulesState> = {
  schedules: schedulesReducer,
  pagination: paginationReducer,
  isLoading: isLoadingReducer,
  query: queryReducer,
  filters: filtersReducer,
  sort: sortReducer,
  hasDeletedSchedules: hasDeletedSchedulesReducer,
  minimumScheduleInterval: minimumScheduleIntervalReducer,
  availableIntervals: availableIntervalsReducer,
};
